<template>
    <v-card width="auto" tile>
        <v-form ref="form">
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" sm="8" md="4">
                        <v-text-field
                            v-model="model.seccion"
                            label="Seccion"
                            outlined
                            :rules="fieldRequired"
                            dense>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" v-if="get_dialogMain.type == 'update'">
                        <v-sheet width="100%" height="100%">
                            <v-switch
                            v-model="model.activo"
                            label="Activo"
                            :value="model.activo"
                            flat/>
                        </v-sheet>
                    </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="4">
                          <v-select
                              v-model="model.municipio_id"
                              label="Municipio"
                              :items="municipios"
                              :rules="fieldRequired"
                              item-text="nombre"
                              item-value="id"
                              outlined
                              dense>
                          </v-select>
                      </v-col>
                      <v-col cols="12" sm="4">
                          <v-select
                              v-model="model.df_id"
                              label="Distrito Federal"
                              :items="federal"
                              :rules="fieldRequired"
                              item-text="nombre"
                              item-value="id"
                              outlined
                              dense>
                          </v-select>
                      </v-col>
                      <v-col cols="12" sm="4">
                          <v-select
                              v-model="model.de_id"
                              label="Distrito Estatal"
                              :items="estatal"
                              :rules="fieldRequired"
                              item-text="nombre"
                              item-value="id"
                              outlined
                              dense>
                          </v-select>
                      </v-col>
                    </v-row>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-end>
                <v-btn class="red darken-1 mr-3" dark @click="onCancel">Cancelar</v-btn>
                <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  props: ['model', 'onSuccess', 'onCancel'],
  data: () => ({
    fieldRequired: [
      value => !!value || 'Campo Requerido.'
    ],
    municipios: [],
    federal: [],
    estatal: []
  }),
  mounted () {
    this.getUrl('mun.get')
    this.getDistritosUrl('distr.est-fed')
  },
  methods: {
    ...mapActions(['getUrlServicesThirdAction', 'getUrlServicesSecoundAction']),
    getUrl (objet) {
      const router = this.get_urls[objet]
      this.getUrlServicesThirdAction(router)
    },
    getDistritosUrl (objet) {
      const router = this.get_urls[objet]
      this.getUrlServicesSecoundAction(router)
    },
    save () {
      if (this.$refs.form.validate()) {
        this.onSuccess(this.model)
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'ERROR',
          text: 'Hay campos obligatorios'
        })
      }
    },
    ...mapMutations([''])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objectsThird', 'get_objectSecound'])
  },
  watch: {
    get_objectsThird (vals) {
      if (vals) {
        this.municipios = vals
      }
    },
    get_objectSecound (val) {
      if (val) {
        this.federal = val.FEDERALES
        // Estatales
        this.estatal = val.ESTATALES
      }
    }
  }
}
</script>

<style>

</style>
